module.exports = __webpack_public_path__ + "assets/img/top_bg.69bf14c1.png";